import { isServer } from '@commons/utils';

const getScreenWidth = () => (!isServer() ? window.innerWidth : null);

export default getScreenWidth;
